// extracted by mini-css-extract-plugin
export var card = "Card-module--card--730d7";
export var description = "Card-module--description--a5370";
export var fadeInAnimation = "Card-module--fadeInAnimation--08464";
export var img = "Card-module--img--9469e";